import { Component, Input, Output, OnInit, Renderer2, EventEmitter, OnDestroy } from '@angular/core';
import { NbSidebarService } from '@nebular/theme';
import { UserQuery } from '../../../@core/akita-stores/stores/user/user.query';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-manage-beverages-layout',
  styleUrls: ['./manage-beverages.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-column class="small sidebar-beverages" id="box-sidebar-beverages">
        <nb-sidebar tag="sidebar-beverages" id="sidebar-beverages" containerFixed="false" state="expanded">
          <sidebar-beverages (calendarChange)="onCalendarChange($event)" id="sidebar-beverages__content"></sidebar-beverages>
        </nb-sidebar>
        <nb-icon pack="mo-icons" icon="chevron-left-alt" id="icon-toggle-sidebar" class="icon-toggle-sidebar" (click)="toggle()"></nb-icon>
      </nb-layout-column>
      <nb-layout-column id="box-main-beverages" class="box-main-beverages__expanded" [nbSpinner]="(isLogin$ | async) == false">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class ManageBeveragesLayoutComponent implements OnInit, OnDestroy {

  @Output() calendarChange:EventEmitter<any> = new EventEmitter();

  isLogin$ = this.userQuery.isLogin$;
  protected destroy$ = new Subject<void>();

  constructor(
    private sidebarService: NbSidebarService,
    private renderer: Renderer2,
    private userQuery: UserQuery,
  ) { }

  ngOnInit() {
    this.renderer.addClass(document.getElementById('icon-toggle-sidebar'), 'd-flex');
    this.renderer.removeClass(document.getElementById('icon-toggle-sidebar'), 'd-none');
    this.sidebarService.onToggle().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.tag == 'sidebar-beverages') {
        const _class = document.getElementById('sidebar-beverages').getAttribute('class');
        if (_class.includes('expanded')) {
          // this.renderer.setStyle(document.getElementById('icon-toggle-sidebar'), 'right', '294px');
          // this.renderer.addClass(document.getElementById('icon-toggle-sidebar'), 'd-none');
          // this.renderer.removeClass(document.getElementById('icon-toggle-sidebar'), 'd-none');
          
          this.renderer.setStyle(document.getElementById('box-sidebar-beverages'), 'max-width', '0px');
          this.renderer.addClass(document.getElementById('sidebar-beverages__content'), 'd-none');
          this.renderer.removeClass(document.getElementById('box-main-beverages'), 'box-main-beverages__expanded');
        } else if (_class.includes('compacted')) {
          // this.renderer.addClass(document.getElementById('icon-toggle-sidebar'), 'd-flex');
          // this.renderer.removeClass(document.getElementById('icon-toggle-sidebar'), 'd-none');

          this.renderer.setStyle(document.getElementById('box-sidebar-beverages'), 'max-width', '360px');
          this.renderer.removeClass(document.getElementById('sidebar-beverages__content'), 'd-none');
          this.renderer.addClass(document.getElementById('box-main-beverages'), 'box-main-beverages__expanded');
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggle() {
    this.sidebarService.toggle(true, 'sidebar-beverages');
  }

  onCalendarChange(event) {
    this.calendarChange.emit(event);
  }
}
